module.exports = __webpack_public_path__ + "img/doc.7e89599b.svg";